import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { twMerge } from '@utils/tw-merge';

// UI
import { getTypographyStylesAsClassName } from './typography-styles';
export type TypographyVariant = 'title1' | 'title2' | 'title3' | 'title4' | 'title5' | 'title6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'small';
export interface ITypographyProps<C extends React.ElementType> {
  /**
   * An override of the default HTML tag.
   * Can also be another React component.
   */
  component?: C;
  /** Applies the theme typography styles */
  variant?: TypographyVariant;
  /** Applies the theme typography styles for medium screens */
  variantM?: TypographyVariant;
  /** Applies the theme typography styles for large screens */
  variantL?: TypographyVariant;
  /** Applies the theme typography styles for xlarge screens */
  variantXL?: TypographyVariant;
  /** Applies the theme typography styles for xxlarge screens */
  variantXXL?: TypographyVariant;
  /** Applies the bold font over the variant */
  bold?: boolean;
}

// export type TypographyProps<C extends React.ElementType> = ITypographyProps<C> &
//   Omit<React.ComponentPropsWithRef<C>, keyof ITypographyProps<C>>;

// Extend Omit to also exclude 'style' and 'className'
export type TypographyProps<C extends React.ElementType> = ITypographyProps<C> & Omit<React.ComponentPropsWithRef<C>, keyof ITypographyProps<C> | 'style'>;
export const Typography = t0 => {
  const $ = _c(34);
  let bold;
  let children;
  let component;
  let propClassName;
  let rest;
  let variant;
  let variantL;
  let variantM;
  let variantXL;
  let variantXXL;
  if ($[0] !== t0) {
    ({
      component,
      variant,
      variantM,
      variantL,
      variantXL,
      variantXXL,
      bold,
      children,
      className: propClassName,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = bold;
    $[2] = children;
    $[3] = component;
    $[4] = propClassName;
    $[5] = rest;
    $[6] = variant;
    $[7] = variantL;
    $[8] = variantM;
    $[9] = variantXL;
    $[10] = variantXXL;
  } else {
    bold = $[1];
    children = $[2];
    component = $[3];
    propClassName = $[4];
    rest = $[5];
    variant = $[6];
    variantL = $[7];
    variantM = $[8];
    variantXL = $[9];
    variantXXL = $[10];
  }
  let t1;
  let t2;
  if ($[11] !== bold || $[12] !== propClassName || $[13] !== rest || $[14] !== variant || $[15] !== variantL || $[16] !== variantM || $[17] !== variantXL || $[18] !== variantXXL) {
    const typographyClassName = getTypographyStylesAsClassName(variant, variantM, variantL, variantXL, variantXXL, bold);
    t1 = rest;
    t2 = twMerge(typographyClassName, propClassName);
    $[11] = bold;
    $[12] = propClassName;
    $[13] = rest;
    $[14] = variant;
    $[15] = variantL;
    $[16] = variantM;
    $[17] = variantXL;
    $[18] = variantXXL;
    $[19] = t1;
    $[20] = t2;
  } else {
    t1 = $[19];
    t2 = $[20];
  }
  let t3;
  if ($[21] !== t1 || $[22] !== t2) {
    t3 = {
      ...t1,
      className: t2
    };
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  const props = t3;
  if (typeof children === "string" || component !== undefined) {
    const Tag = component || "span";
    let t4;
    if ($[24] !== Tag || $[25] !== children || $[26] !== props) {
      t4 = <Tag {...props}>{children}</Tag>;
      $[24] = Tag;
      $[25] = children;
      $[26] = props;
      $[27] = t4;
    } else {
      t4 = $[27];
    }
    return t4;
  }
  if (!children) {
    return null;
  } else {
    if (React.Children.count(children) === 1 && React.isValidElement(children)) {
      let t4;
      if ($[28] !== children) {
        t4 = React.Children.only(children);
        $[28] = children;
        $[29] = t4;
      } else {
        t4 = $[29];
      }
      const child = t4;
      const t5 = child.props as object;
      let t6;
      if ($[30] !== child.type || $[31] !== props || $[32] !== t5) {
        t6 = <child.type {...t5} {...props} />;
        $[30] = child.type;
        $[31] = props;
        $[32] = t5;
        $[33] = t6;
      } else {
        t6 = $[33];
      }
      return t6;
    } else {
      throw new Error("Typography component expects one children tree or a string");
    }
  }
};